var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#FBCB88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.6406C17.8767 22.6406 22.6406 17.8767 22.6406 12C22.6406 6.12335 17.8767 1.35938 12 1.35938C6.12335 1.35938 1.35938 6.12335 1.35938 12C1.35938 17.8767 6.12335 22.6406 12 22.6406Z",
    fill: "#FFF8EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0138 7.70017C11.6875 7.70743 11.3701 7.59335 11.1231 7.38001C10.876 7.16626 10.7524 6.86408 10.7524 6.47345C10.7479 6.30879 10.7796 6.14515 10.8453 5.99409C10.911 5.84303 11.009 5.70823 11.1325 5.59923C11.372 5.37579 11.6882 5.25295 12.0156 5.25611C12.3306 5.25295 12.6362 5.36346 12.8763 5.56736C13.1263 5.77455 13.2513 6.07658 13.2513 6.47345C13.2513 6.85783 13.1292 7.15845 12.8852 7.37533C12.6463 7.59007 12.3349 7.70616 12.0138 7.70017ZM13.2499 10.282V17.5055C13.2499 18.0055 13.1308 18.3839 12.8927 18.6408C12.7781 18.7663 12.6379 18.8656 12.4816 18.932C12.3252 18.9984 12.1564 19.0303 11.9866 19.0256C11.62 19.0256 11.3224 18.8944 11.0936 18.6319C10.8649 18.3694 10.7505 17.9944 10.7505 17.5069V10.3552C10.7505 9.86111 10.8649 9.48892 11.0936 9.23861C11.3224 8.9883 11.62 8.8633 11.9866 8.86361C12.3525 8.86361 12.6546 8.98861 12.8927 9.23861C13.1308 9.48861 13.2499 9.83642 13.2499 10.282Z",
    fill: "#FBCB88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarn);
export default __webpack_public_path__ + "static/media/warn.dcb2cf03d84bd2eb51849c3f5419138e.svg";
export { ForwardRef as ReactComponent };